<template>
  <div class="logo">
    <div>
      <img src="/logo.png" />
      <h1 v-if="showTitle">{{ title }}</h1>
    </div>
  </div>
</template>

<script>
import { i18nRender } from '@/locales'

export default {
  name: 'Logo',
  props: {
    title: {
      type: String,
      default: i18nRender('menu.title'),
      required: false
    },
    showTitle: {
      type: Boolean,
      default: true,
      required: false
    }
  }
}
</script>
<style>
  .ant-layout-sider .logo{
    background: transparent !important;
  }
</style>
